import { Table, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react"
import { FC } from "react"
import { DeleteIconButton } from "src/components/ui/iconButtons/DeleteIconButton"
import { EditIconButton } from "src/components/ui/iconButtons/EditIconButton"
import { IShop } from "src/domain/entities"
import { getFullName, toINR } from "src/utils/helpers"

export const ShopListView: FC<{
	list: IShop[]
	onUpdate: (shop: IShop) => void
	onDelete: (shop: IShop) => void
}> = ({ list, onUpdate, onDelete }) => (
	<Table size={"sm"}>
		<Thead>
			<Tr>
				<Th>Block No.</Th>
				<Th>Current Rentee</Th>
				<Th isNumeric>Rent</Th>
				<Th>Note</Th>
				<Th isNumeric>Actions</Th>
			</Tr>
		</Thead>
		<Tbody>
			{list.map((shop, i) => (
				<Tr key={i}>
					<Td>{shop.blockNo}</Td>
					<Td>{getFullName(shop.currentRentee)}</Td>
					<Td isNumeric>{toINR(shop.rent)}</Td>
					<Td>{shop.note || "-"}</Td>
					<Td isNumeric>
						<EditIconButton onClick={() => onUpdate(shop)} />
						<DeleteIconButton onClick={() => onDelete(shop)} />
					</Td>
				</Tr>
			))}
		</Tbody>
	</Table>
)
